<template>
	<div class="realty" :class="{'isiOSX':isiOSX}">
		<van-nav-bar v-if="isApp" title="招募地产项目" :fixed="true"/>
    	<img v-if="isApp" @click="goBack()" class="reback" src="../../assets/myInvest/reback.png">
    	<img v-if="isApp" @click="applyMerchantShare()" class="share" src="../../assets/common/xb_title_share.png">
		<van-row>
			<van-col span="24" class="banner" :style="paddT">
				<img src="../../assets/advDetail/realty/dc_01.jpg">
				<img src="../../assets/advDetail/realty/dc_02.jpg">
				<img src="../../assets/advDetail/realty/dc_03.jpg">
				<img src="../../assets/advDetail/realty/dc_04.jpg">
				<img src="../../assets/advDetail/realty/dc_05.jpg">
				<img src="../../assets/advDetail/realty/dc_06.jpg">
			</van-col>
			
			<van-col span="24">
				<a class="btn" href="tel:057186751636" onclick="iOStel()">
			        <img src="../../assets/advDetail/realty/tel.png" class="image" alt="">
			        <div class="text">合作咨询</div>
			    </a>
			</van-col>
			
		</van-row>
	</div>
</template>

<script>
export default {
  data() {
    return {
    	isApp: true,
    	isiOSX: false,
    	paddT: {paddingTop: '68px'} //app内
    };
  },
  created(){
  	this.isiOSX = this.isIphoneX();
  	if(this.$route.query.from) {//app外
  		this.isApp = false;
  		this.paddT = {paddingTop: '0'}
  	}else {
  		if(this.isiOSX) {//app内齐刘海
  			this.paddT = {paddingTop: '88px'}
  		}
  	}
  },
  methods: {
  	goBack() {
  		this.params('', '', 'goBack');
  	},
    iOStel() {
		let ua = navigator.userAgent.toLowerCase();
		if (/iphone|ipad|ipod|macintosh/i.test(ua) && !this.$route.query.from) {
	        this.phone();
	    }
	},
	phone() {
		this.tel = '057186751636';
		this.params(this.tel, this.tel, 'phone');
	},
	applyMerchantShare() {
    	this.params('', '', 'applyMerchantShare');
    }
  }
};
</script>

<style lang="less">
.realty {
	min-height: 100%;
	color: #fff;
	.van-nav-bar {
	    height: 44px;
	    line-height: 44px;
	    padding-top: 24px;
	    box-shadow: 0 1px 0 #eee;
	    .van-nav-bar__title {
	      color: #333;
	      font-size: 17px;
	      font-weight: 700;
	    }
	}
	.reback {
	    width: 15px;
	    padding: 12px 15px;
	    position: fixed;
	    top: 27px;
	    left: 0;
	    z-index: 1;
	}
	.share {
		width: 15px;
	    padding: 12px 15px;
	    position: fixed;
	    top: 27px;
	    right: 0;
	    z-index: 1;
	}
	.banner {    
		padding-bottom: 50px;
		img {
			width: 100%;
			display: block;
			height: auto;
		}
	}
    .btn {
        position: fixed;
        width: 100%;
        bottom: 0;
        height: 50px;
        background: #FFFFFF;
        color: #264AA0;
        display: flex;
        align-items: center;
        justify-content: center;
        text-decoration: none;
        .image {
            width: 20px;
            height: 20px;
        }
        .text {
            margin-left: 7px;
        }
    }
	
	
}

.isiOSX {
	.van-nav-bar {
		padding-top: 44px;
	}
	.reback {
		top: 47px;
	}
	.share {
		top: 47px;
	}
}


</style>
